import { render, staticRenderFns } from "./DHPlayer.vue?vue&type=template&id=7d945bfc&scoped=true"
import script from "./DHPlayer.vue?vue&type=script&lang=js"
export * from "./DHPlayer.vue?vue&type=script&lang=js"
import style0 from "./DHPlayer.vue?vue&type=style&index=0&id=7d945bfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d945bfc",
  null
  
)

export default component.exports